import { useMissionsTranslation } from '../../../../ui/hooks';
import { showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { Alert, Box, Button, Typography } from '@mui/material';
import React from 'react';
export const DeleteVolunteeringHours = ({ selectedRowIds, onDeleteHours, disableDelete }) => {
    const { t } = useMissionsTranslation();
    const handleOnClick = (selectedIds) => {
        const singleRecord = selectedIds.length === 1;
        showConfirmDialog({
            title: singleRecord
                ? t('timeTracking.deleteHoursDialog.singleRecordTitle')
                : t('timeTracking.deleteHoursDialog.multipleRecordsTitle', { quantity: selectedIds.length }),
            content: (React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 2 } },
                React.createElement(Alert, { severity: 'warning' },
                    React.createElement(Typography, { variant: 'subtitle2' }, t('timeTracking.deleteHoursDialog.alert'))),
                React.createElement(Typography, { variant: 'body1' }, singleRecord
                    ? t('timeTracking.deleteHoursDialog.singleRecordContent')
                    : t('timeTracking.deleteHoursDialog.multipleRecordsContent')))),
            confirmLabel: t('common.delete'),
            onConfirm: () => onDeleteHours({ participationIds: selectedRowIds }),
        });
    };
    return (React.createElement(Button, { sx: { width: { xs: '100%', md: 'auto' } }, variant: 'outlined', size: 'large', onClick: () => handleOnClick(selectedRowIds), disabled: disableDelete, "data-test": 'delete-button' }, t('common.delete')));
};
